import PortalRing from "./stories/PortalRing";
import "./people/people.css";

export default function FriendEventFilter({
  friends,
  selected,
  onToggle,
  onClear,
}) {
  return (
    <div className="people-filter" aria-label="Filter by friend">
      <button type="button" onClick={onClear} aria-pressed={!selected.size}>
        <span className="people-filter-all">ALL</span>
        <span className="people-filter-name">Everyone</span>
      </button>
      {friends.map((friend) => (
        <button
          type="button"
          key={friend.userId}
          onClick={() => onToggle(friend.userId)}
          aria-pressed={selected.has(friend.userId)}
          aria-label={"Filter by " + friend.name}
        >
          <span className="people-filter-face">
            <PortalRing
              size={68}
              state={friend.livePortalCount ? "live" : "seen"}
              avatarUrl={friend.avatarUrl}
              initial={(friend.name || "?")[0]}
            />
            {friend.livePortalCount > 0 && (
              <span className="people-filter-live">
                {friend.livePortalCount} live
              </span>
            )}
          </span>
          <span className="people-filter-name">{friend.name}</span>
        </button>
      ))}
    </div>
  );
}
